<div class="d-flex flex-column gap-3 w-100">
  <!-- <div class="modal-body"> -->
  <div class="d-flex align-items-center gap-2">
    <i class="bi bi-file-earmark-text fs-20"></i>
    <h3 class="m-0">{{ template()?.name + '.' + template()?.fileType | titlecase }}</h3>
  </div>
  <div class="flex-fill h-100 rounded-4 bg-light overflow-hidden">
    <div class="row h-100">
      <div class="col-lg-2 col-md-4 col-12 h-100">
        <div class="p-3 rounded-4 border bg-white d-flex flex-column gap-2 h-100">
          <div class="bg-white p-2 rounded border">
            <p class="mb-1">Template Variable Set: <b class="fw-500">Default</b></p>
            <p class="m-0">
              Total Values: <b class="fw-500">{{ tempVariables()?.length ?? 0 }}</b>
            </p>
          </div>
          <div class="flex-fill overflow-y-auto d-flex flex-column gap-2 me-n3 pe-3">
            @for (variable of tempVariables() ?? []; track $index) {
              <div class="bg-white p-2 rounded border">
                <p class="mb-0 text-truncate" [title]="variable">{{ variable }}</p>
              </div>
            }
          </div>
        </div>
      </div>
      <div class="col-lg-10 col-md-8 col-12 h-100">
        <div class="overflow-y-auto">
          @if (template()?.s3Document?.directUrl) {
            <lib-doc-preview [article]="template()?.s3Document?.directUrl!"></lib-doc-preview>
          } @else {
            <p class="text-center text-muted">No template document found</p>
          }
        </div>
      </div>
    </div>
  </div>

  <button type="button" class="btn btn-primary ms-auto btn-h40" (click)="downloadDocument()">
    <i class="bi bi-download"></i>
    Download
  </button>
</div>
